import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'status_humanizer'
})
export class HumanizePipe implements PipeTransform {

  public transform(value: any, ...args: any[]): any {
    if ((typeof value) !== 'string') {
      return value;
    }
    value = value.split(/(?=[A-Z])/).join(' ');
    value = value[0].toUpperCase() + value.slice(1);
    return value;
  }
}

